import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Container, Navbar, NavbarBrand, NavbarToggler,  Dropdown, DropdownToggle, DropdownMenu, DropdownItem  } from 'reactstrap';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { NotificationPill } from './notifications';
import AlarmPill from './AlarmHeader';
import { SitePicker } from './sitepicker.js';
import { Badge } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { languageLabels, langIDs } from '../i18n';

export function NavMenu(props) {
    const [dropdownOpen, setdropdownOpen] = useState(false)
    const history = useHistory();
    const location = useLocation();
    const [Name, setName] = useState("Manage Account")
    const [role, setRole] = useState();
    const [alarms, setAlarms] = useState();
    const [AlarmsTabVisible, setAlarmsTabVisible] = useState(false);
    const [IsSuperAdmin, setIsSuperAdmin] = useState(false);

    useEffect(() => {
        $.ajax({
            url: '/api/AuthorizationAPI/IsSuperAdmin',
            type: 'get',
            success: function (response) {
                setIsSuperAdmin(response === true);
            }
        });
    }, []);
    const [AlarmsPresent, setAlarmsPresent] = useState(false);
    const [NSites, setNSites] = useState(1);

    const { t, i18n } = useTranslation();

    const changeLanguage = (event) => {
        i18n.changeLanguage(event.target.value);
        console.log(i18n.language);
        console.log(t('language'));
    };

    useEffect(() => {
        //Fetch name
        $.ajax({
            url: '/api/NavBarAPI/GetName',
            type: 'get',
            success: function (response) {
                setName(response)
            },
            error: function (response) {
                // Back to this page after signing in
                const returnUrl = location.pathname.includes('Login') ? '/' : location.pathname + location.search;
                window.location = "/Identity/Account/Login?returnUrl=" + encodeURIComponent(returnUrl);
            }
        })
        
    }, []);

    useEffect(() => {
        // Fetch role
        var url = "/api/AuthorizationAPI/GetRoleLabel?siteGUID=" + props.SiteGUID;
        if (props.SiteGUID) {
            fetch(url).then(response => response.json())
                .then(data => {
                    setRole(data);
                });
        }

        // Fetch alarms
        $.ajax({
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            type: 'POST',
            data: JSON.stringify({ "SiteGUID": props.SiteGUID }),
            url: '/api/NavBarAPI/Post',
            success: function (data) {
                setAlarmsTabVisible(data.alarmsTabActive);
                setAlarmsPresent(data.alarmsPresent);
            }
        });

        var d = new Date();
        var offset = (d.getTimezoneOffset() * -1) / 60;
        $.ajax({
            url: '/api/AlarmsAPI/GetActiveAlarms',
            type: 'get',
            data: { SiteGUID: props.SiteGUID, offset: offset },
            success: function (response) {
                response = JSON.parse(response);
                setAlarms(response);

            }
        });


    }, [props.SiteGUID])

    function ChangeSitePicker(newSiteGUID) {
        if (location.pathname === '/') {
            history.push('/' + newSiteGUID)
        } else if (location.pathname.includes('ControlChains')) {
            history.push('/ControlChains/index/' + newSiteGUID);
        } 
        else {
            history.push(location.pathname.replace('/' + props.SiteGUID, '/' + newSiteGUID))
        }
        props.setSiteGUID(newSiteGUID);
    }

    var languages = [];
    for (var i = 0; i < langIDs.length; i++) {
        languages.push(<DropdownItem disabled={true} key={langIDs[i]} onClick={changeLanguage} value={langIDs[i]}>{languageLabels[langIDs[i]]}</DropdownItem>)
    }
    return (
        <>
            <header>
                <Navbar className="fixed-top navbar-expand-sm navbar-toggleable-sm bg-white border-bottom box-shadow mb-3" light>
                    <Container className="themed-container" fluid={true}>
                        <NavbarBrand tag={Link} to={NSites > 1 ? "/" : ("/" + props.SiteGUID)}>
                            <img className="navbar-brand p-0" alt="Home" width="320" height="70" src="/images/StreamwiseAI-Corporate-Identity-Horizontal-Colour-Without-Dots.svg" />
                        </NavbarBrand>
                    </Container>
                    <NavbarToggler onClick={props.mobileCollapse} className="me-2" />
                    <Dropdown isOpen={dropdownOpen} toggle={() => setdropdownOpen(!dropdownOpen)} className="me-3">
                        <DropdownToggle caret outline>
                            {i18n.language !== undefined ? languageLabels[i18n.language] : "English"}
                        </DropdownToggle>
                        <DropdownMenu>
                            {languages}
                        </DropdownMenu>
                    </Dropdown>
                    <SitePicker setNSites={setNSites} SiteChangeHandler={ChangeSitePicker} SiteGUID={props.SiteGUID} />
                    {AlarmsTabVisible && alarms !== undefined ?
                        <AlarmPill SiteGUID={props.SiteGUID} alarms={alarms} />
                        :
                        <></>
                    }
                    <NotificationPill SiteGUID={props.SiteGUID} />
                    <div>
                        <div>
                            <a tag={Link} className="text-dark" href="/Identity/Account/Manage">{Name}</a>
                        </div>
                        <div>
                            {role && 
                                <Badge bg={role.variant} >{role.name}</Badge>
                            }
                        </div>
                    </div>
                    {IsSuperAdmin ?
                        <Link className="nav-link" to="/admin" title="Admin">
                            <i className="fas text-dark fa-2x fa-user-shield"></i>
                        </Link>
                        : <></>
                    }
                    {Name == "Manage Account" ? "" : <a tag={Link} style={{ marginTop: 0, marginBottom: 0 }} className="nav-link" href="/Identity/Account/Logout">
                        <i className="fas text-dark fa-2x fa-sign-out-alt"></i>
                    </a>}
                </Navbar>
            </header>
        </>
    );
}
